import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    scroll-padding-top: 76px;
  }

  body {
    min-width: 320px;
    overflow-x: hidden;
    background: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    font-family: ${props => props.theme.fonts.sans};
    font-size: 16px;
    line-height: 1.65;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button, input, textarea, select {
    font: inherit;
  }

  button, a {
    -webkit-tap-highlight-color: transparent;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${props => props.theme.colors.textPrimary};
    font-family: ${props => props.theme.fonts.display};
    font-weight: 700;
    line-height: 1.08;
  }

  p {
    text-wrap: pretty;
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: color ${props => props.theme.transitions.fast};
  }

  a:hover {
    color: ${props => props.theme.colors.secondary};
  }

  code, pre {
    font-family: ${props => props.theme.fonts.mono};
  }

  code {
    padding: 0.08rem 0.3rem;
    border: 1px solid ${props => props.theme.colors.border};
    border-radius: 0.25rem;
    background: ${props => props.theme.colors.surfaceLight};
    color: ${props => props.theme.colors.secondary};
  }

  pre {
    overflow-x: auto;
    border-radius: 0.4rem;
    background: ${props => props.theme.colors.terminal.background};
    color: #d7dee8;
  }

  ::selection {
    background: rgba(0, 113, 227, 0.2);
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.surfaceLight};
  }

  ::-webkit-scrollbar-thumb {
    border: 2px solid ${props => props.theme.colors.surfaceLight};
    border-radius: 999px;
    background: #9da6aa;
  }

  :focus-visible {
    outline: 3px solid rgba(0, 113, 227, 0.28);
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
